import swaggerClient from "./../remote-client";
import Utils from "../Utils";

export default class BookingsServiceImpl {
  /**
   * Get covered provinces by Fondo Est
   */
  getProvincesCovered() {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(
        client => {
          return client.apis.Appointment.getProvincesCovered(
            {},
            swaggerClient.buildRequest(),
            {}
          )
            .then(res => {
              let provinces = res.body.coveredList.map(province => {
                let p = province;
                p.province["covered"] = p.covered;
                delete p.covered;
                return p.province;
              });
              resolve(provinces);
            })
            .catch(error => reject(error));
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      );
    });
  }

  /**
   * get list of health plan services (name and aliases for autocomplete) (TBD in the member healthPlans)
   * @param payload {search,provinceCode}
   */
  getServiceNames(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient.then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getServiceNamesOfficeWithOfficeId(
            payload,
            swaggerClient.buildRequest(),
            {}
          )
            .then(res => resolve(res.body.serviceList))
            .catch(error => reject(error));
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      );
    });
  }

  /**
   * get list of doctors (autocomplete)
   * province
   * serviceId
   * obese
   * claustrophobia
   * toSearch
   *
   * FIXME lll --> SEEMS THAT getDoctors ENDPOINT DOES NOT EXIST ANYMORE
   */
  getDoctors(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(
        client => {
          return client.apis.Appointment.getDoctors(
            payload,
            swaggerClient.buildRequest(),
            {}
          )
            .then(res => resolve(res.body.doctorList))
            .catch(error => reject(error));
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      );
    });
  }

  getDoctorsByOfficeService(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient.then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getDoctorsOfficeWithIdServiceWithServiceId(
            payload,
            swaggerClient.buildRequest(),
            {}
          )
            .then(res => resolve(res.body.doctors))
            .catch(error => reject(error));
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      );
    });
  }

  /**
   * Returns the office info based on doctorId and officeserviceId
   * @param {*} payload
   *
   * FIXME lll --> SEEMS THAT getOfficeserviceWithOfficeserviceId ENDPOINT DOES NOT EXIST ANYMORE
   */
  getOfficeService(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(
        client => {
          return client.apis.Appointment.getOfficeserviceWithOfficeserviceId(
            payload,
            swaggerClient.buildRequest(),
            {}
          )
            .then(res => resolve(res.body.hfOffice))
            .catch(error => reject(error));
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      );
    });
  }

  /**
   * get member residual ceiling for specified health plan service
   * @param {*} id
   */
  getCeilingServiceWithId(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient.then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getCeilingOfficeWithOfficeIdMemberWithMemberFiscalCodeServiceWithIdYearWithYear(
            payload,
            swaggerClient.buildRequest(),
            {}
          )
            .then(res => resolve(res.body))
            .catch(error => reject(error));
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      );
    });
  }

  /**
   * get info for specified health plan service
   * @param {*} id
   */
  getServiceWithId(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient.then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postServiceServiceIdOfficeOfficeId(
            {},
            swaggerClient.buildRequest(payload),
            {}
          )
            .then(res => resolve(res.body.service))
            .catch(error => reject(error));
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      );
    });
  }

  getSlotsForMonths(payload) {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getSlotOfficeWithIdOfficeserviceWithOfficeserviceIdMonth(
            payload,
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(result => {
        return result.body;
      })
      .catch(reason => {
        if (reason == "TypeError: Failed to fetch") {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason
          });
        } else if (reason.status === 412) {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        } else return Promise.reject({ type: Utils.errorTypes.CUSTOM, reason });
      });
  }

  getOperationalService(payload) {
    return Promise.resolve({
      serviceId: "09a2043f-3ab6-4a66-9214-88e8d530e5c8",
      macroArea: "DGN",
      area: "ENDOSCOPIE",
      nameByLang:
        "Anorettoscopia diagnostica (inclusa biopsia ed esame istologico)",
      servicePrice: "EUR 72.00"
    });
    // return new Promise((resolve, reject) => {
    //   swaggerClient.memberSwaggerClient.then(client => {
    //     return client.apis.Appointment.getOperationalServiceWithOfficeService(
    //       payload,
    //       swaggerClient.buildRequest(),
    //       {}
    //     )
    //       .then(res => resolve(res.body.service))
    //       .catch(error => reject(error));
    //   });
    // });
  }

  sendAppointment(params, payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient.then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.postAppointmentOfficeWithOfficeIdMemberWithMemberFiscalCode(
            params,
            swaggerClient.buildRequest(payload),
            {}
          )
            .then(res => resolve(res.body))
            .catch(error => reject(error));
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      );
    });
  }

  callGetServiceBookingInfo(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient.then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getBookingInfoOfficeWithOfficeIdServiceWithServiceIdMemberWithMemberFiscalCode(
            payload,
            swaggerClient.buildRequest(),
            {}
          )
            .then(res => resolve(res.body.bookingInfo))
            .catch(error => reject(error));
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      );
    });
  }

  callGetNewServiceBookingInfo(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.hfportalSwaggerClient.then(
        client => {
          return client.apis.HealthFacilityAppointmentsManagement.getBookingInfoOfficeWithOfficeIdAppointmentWithAppointmentIdServiceWithServiceIdMemberWithMemberFiscalCode(
            payload,
            swaggerClient.buildRequest(),
            {}
          )
            .then(res => resolve(res.body.bookingInfo))
            .catch(error => reject(error));
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      );
    });
  }
}
